<template>
    <Head title="Daftar Tagihan" />
    <div v-if="hasPermission(['tagihan import']) || hasRole(['Super Admin'])">
        <div class="row mb-2">
            <progress v-if="form.progress" :value="form.progress.percentage" max="100" style="width: 100%">
                {{ form.progress.percentage }}%
            </progress>
        </div>
        <form @submit.prevent="importTagihan">
            <div class="row">
                <div class="col-sm-4">
                    <input-file label="" @input="form.excel = $event.target.files[0]" :error="form.errors.excel" type="file"
                        accept=".xls,.xlsx" />
                </div>
                <div class="col-sm-2">
                    <button type="submit" class="btn btn-info mb-3" :disabled="form.processing">
                        Import Tagihan
                    </button>
                </div>
                <div class="col-sm-6">
                </div>
            </div>
        </form>
    </div>
    <div id="accordion">
        <div class="card card-primary">
            <div class="card-header">
                <h4 class="card-title w-100">
                    <a class="d-block w-100" data-toggle="collapse" href="#collapseOne">
                        SARING DATA
                    </a>
                </h4>
            </div>
            <div id="collapseOne" class="collapse" data-parent="#accordion">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm">
                            <input-select2 v-if="isTeam == false" v-model="form.team" :error="form.errors.team" 
                                :options="teams" :settings="{
                                    placeholder: 'Pilih Team ...',
                                    allowClear: true,
                                }" name="team" class="form-control filter-select">
                            </input-select2>
                            <input-select2 v-else v-model="form.onsite" :error="form.errors.onsite" 
                                :options="onsites" :settings="{
                                    placeholder: 'Dikunjungi ...',
                                    allowClear: true,
                                }" name="onsite" class="form-control filter-select">
                            </input-select2>
                        </div>
                        <div class="col-sm">
                            <input-select2 v-model="form.bayar" :error="form.errors.bayar" 
                                :options="onsites" :settings="{
                                    placeholder: 'Pembayaran ...',
                                    allowClear: true,
                                }" name="bayar" class="form-control filter-select">
                            </input-select2>
                        </div>
                        <div class="col-sm">
                            <input-select2 v-model="form.centang" :error="form.errors.centang" 
                                :options="centangs" :settings="{
                                    placeholder: 'Pilih Tagihan ...',
                                    allowClear: true,
                                }" name="centang" class="form-control filter-select">
                            </input-select2>
                        </div>
                        <div class="col-sm">
                            <input-text name="kantor" class="form-control filter-input" placeholder="Kode Kantor" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="card card-outline card-primary">
        <div class="card-header">
            <h3 class="card-title">DAFTAR TAGIHAN</h3>
            <div class="card-tools">
                <Link href="/home" class="btn btn-tool">
                <i class="fas fa-times"></i>
                </Link>
            </div>
        </div>
        <div class="card-body table-responsive">
            <data-table v-if="isTeam" :columns="columnsTeam" :ajax="ajax" :order="[3,'asc']" 
                :columnDefs="[{ targets: [7, 8, 9], className: 'dt-body-right' }]"></data-table>
            <data-table v-else :columns="columns" :ajax="ajax" :order="[3,'asc']" 
                :columnDefs="[{ targets: [7, 8, 9], className: 'dt-body-right' }]"></data-table>
        </div>
    </div>
</template>
  
<script>
import Layout from "@/Layouts/Master";
import { Head, Link } from "@inertiajs/vue3";
import InputText from "@/Forms/InputText";
import InputSelect2 from "@/Forms/InputSelect2";
import InputFile from "@/Forms/InputFile";
import DataTable from '@/Forms/DataTable'

export default {
    layout: Layout,
    components: {
        Head,
        Link,
        InputText,
        InputSelect2,
        InputFile,
        DataTable,
    },
    props: {
        isTeam: Boolean,
    },
    data() {
        return {
            columns: [
                { title: 'No', data: 'DT_RowIndex', orderable: false, searchable: false },
                { title: 'Kantor', data: 'kantor' },
                { title: 'Rekening', data: 'rek' },
                { title: 'Nama', data: 'nama' },
                { title: 'Alamat', data: 'alamat' },
                { title: 'Bsr Angs', data: 'angsuran' },
                { title: 'Macet', data: 'bln_tung' },
                { title: 'Titipan', data: 'titipan' },
                { title: 'Tunggakan', data: 'tunggakan' },
                { title: 'Angsuran', data: 'dana_masuk' },
                { title: 'Jaminan', data: 'jaminan' },
                { title: 'Team', data: 'team' },
                { title: 'Aksi', data: 'action', orderable: false, searchable: false, }
            ],
            columnsTeam: [
                { title: 'No', data: 'DT_RowIndex', orderable: false, searchable: false },
                { title: 'Kantor', data: 'kantor' },
                { title: 'Rekening', data: 'rek' },
                { title: 'Nama', data: 'nama' },
                { title: 'Alamat', data: 'alamat' },
                { title: 'Bsr Angs', data: 'angsuran' },
                { title: 'Macet', data: 'bln_tung' },
                { title: 'Titipan', data: 'titipan' },
                { title: 'Tunggakan', data: 'tunggakan' },
                { title: 'Angsuran', data: 'dana_masuk' },
                { title: 'Jaminan', data: 'jaminan' },
                { title: 'Aksi', data: 'action', orderable: false, searchable: false, }
            ],
            ajax: {
                url: '/datatables/tagihan',
                data: function (d) {
                    d.kantor = $("input[name=kantor]").val()
                    d.team = $("select[name=team]").val()
                    d.centang = $("select[name=centang]").val()
                    d.onsite = $("select[name=onsite]").val()
                    d.bayar = $("select[name=bayar]").val()
                },
            },
            form: this.$inertia.form({
                excel: null,
            }),
            teams: [
                { id: "TEAM A", text: "TEAM A" },
                { id: "TEAM B", text: "TEAM B" },
                { id: "TEAM C", text: "TEAM C" },
                { id: "TEAM D", text: "TEAM D" },
                { id: "TEAM E", text: "TEAM E" },
                { id: "TEAM F", text: "TEAM F" },
                { id: "TEAM G", text: "TEAM G" },
            ],
            centangs: [
                { id: 1, text: "Bawah" },
                { id: 2, text: "Atas" },
                { id: 3, text: "Macet" },
                { id: 4, text: "CHR" },
            ],
            onsites: [
                { id: 0, text: "Belum" },
                { id: 1, text: "Sudah" },
            ],
        }
    },
    methods: {
        importTagihan() {
            this.form.post("/tagihan/import", {
                forceFormData: true,
                preserveScroll: true,
                onSuccess: () => {
                    toastr.success("Import Tagihan berhasil", "SUKSES");
                    $("#dt-table").DataTable().ajax.reload();
                },
            });
        },
    },
    mounted() {
        $('.filter-input').keyup(function (e) {
            $("#dt-table").DataTable().ajax.reload()
            e.preventDefault();
        })
        $('.filter-select').on('change', function (e) {
            $("#dt-table").DataTable().ajax.reload()
            e.preventDefault();
        });
    }
};
</script>
